import { VALIDATION_ERROR_KEYS } from "@/i18n"
import * as z from "zod"

export const boolean = z.enum(["true", "false"], VALIDATION_ERROR_KEYS.REQUIRED)

export const requiredString = z
  .string(VALIDATION_ERROR_KEYS.REQUIRED)
  .min(1, VALIDATION_ERROR_KEYS.REQUIRED)

export const optionalString = z.string().optional().nullable()
